import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {useAuth} from './AuthContext';

export default function ProtectedRoute({children}) {
    const {isAuthenticated, isLoading} = useAuth();
    const location = useLocation();

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-lg">Loading...</div>
            </div>
        );
    }

    if (!isAuthenticated) {
        // Redirect to login page, but save the attempted URL
        return <Navigate to="/login" state={{from: location}} replace />;
    }

    return children;
}
